import cc from "classnames"
import { useTranslation } from "react-i18next"
import { useStore } from "@nanostores/react"

import type { LayoutDef } from "@types"
import { $auth } from "@stores/auth"

import Link from "@components/Link"
import Container from "@components/Container"
import AccountActionDropdown from "./AccountActionDropdown"

interface PreNavProps {
  layout?: LayoutDef
  bg_color?: "transparent" | "white"
}

const PreNav = (props: PreNavProps): JSX.Element => {
  const { layout, bg_color } = props
  const auth = useStore($auth)
  const { user } = auth
  const { t } = useTranslation<string>("common")

  return (
    <div
      className={cc("text-black z-20 relative", {
        "bg-neutral-100": bg_color === "white",
        "bg-mustard": bg_color === "transparent",
      })}
    >
      <Container>
        <div className={`py-10 justify-between flex items-center md:py-0 h-[var(--hp-navigation-pre-nav-height)]`}>
          <div className="text-14 flex items-center mx-auto md:mx-0">
            {layout?.pre_nav_copy}
            <Link href={layout?.pre_nav_link_url || "/"} class_name="link-hover-underline-inverted font-semibold ml-4">
              {layout?.pre_nav_link_copy}
            </Link>
          </div>

          <div className="hidden md:flex items-center">
            <Link href="/community" class_name="text-14 mr-16 link-hover-underline">
              {t("header.communityLink")}
            </Link>
            <Link href="/creators" class_name="text-14 mr-16 link-hover-underline">
              {t("header.partnerLink")}
            </Link>
            <Link href="/faq" class_name="text-14 mr-16 link-hover-underline">
              {t("header.faq")}
            </Link>
            <div
              className={cc("w-px h-16 mr-16", {
                "bg-neutral-200": props.bg_color === "white",
                "bg-vantablack bg-opacity-10": props.bg_color === "transparent",
              })}
            />
            <div className="flex items-center gap-x-8">
              {user ? (
                <>
                  <AccountActionDropdown bg_color={bg_color} user={user} />
                  {/* <CountryPicker /> */}
                </>
              ) : (
                <>
                  <Link
                    href="/sign-up"
                    class_name={cc("text-14 flex items-center border rounded-8 h-28 pl-8 pr-12 font-semibold", {
                      "border-neutral-200": props.bg_color === "white",
                      "border-vantablack border-opacity-10": props.bg_color === "transparent",
                    })}
                    data-cy="header-login-link"
                  >
                    {t("header.login")}
                  </Link>
                  {/* <CountryPicker /> */}
                </>
              )}
            </div>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default PreNav
